<template>
  <SettingsForm />
</template>

<script>
import SettingsForm from '@/components/settings/SettingsForm.vue'

export default {
  name: 'SettingsView',
  components: {SettingsForm},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
